import React from 'react';
import Banner from './components/banner/Banner';
import Contact from './components/contact/Contact';
// import Footer from "./components/footer/Footer";
import FooterBottom from './components/footer/FooterBottom';
import Navbar from './components/navbar/Navbar';
import Projects from './components/projects/Projects';
import Resume from './components/skill/Resume';
// import Testimonial from "./components/tesimonial/Testimonial";
import About from './components/about/About';
import Services from './components/servic/Services';

function App() {
  return (
    <div className="w-full h-auto bg-bodyColor text-lightText px-4">
      <Navbar />
      <div className="max-w-screen-xl mx-auto">
        <Banner />
        <About />
        <Services />
        <Projects />
        <Resume />
        {/* <Testimonial /> */}
        <Contact />
        {/* <Footer /> */}
        <FooterBottom />
      </div>
    </div>
  );
}

export default App;
